import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navr from '../Navbar/Navr';
import Footer from './Footer';

function Contact() {
  const form = useRef(); // Form ka reference
  const [loading, setLoading] = useState(false); // Button loading state ke liye
  const [submitted, setSubmitted] = useState(false); // Success message ke liye

  const sendEmail = (e) => {
    e.preventDefault(); // Page reload hone se rokne ke liye
    setLoading(true);

    // --- IMPORTANT: Yahan apni IDs replace karein ---
    const serviceID = "service_32nnpdb"; 
    const templateID = "template_9r7ued6";
    const publicKey = "FMIVfFe5FrndURSkh";

    emailjs.sendForm(serviceID, templateID, form.current, publicKey)
      .then((result) => {
          console.log('SUCCESS!', result.text);
          setLoading(false);
          setSubmitted(true);
          e.target.reset(); // Form clear kar dega
          
          // 5 second baad success message hata dega
          setTimeout(() => setSubmitted(false), 5000);
      },(error) => {
    console.log('FAILED...', error); // .text hata diya, ab pura error dikhega
    setLoading(false);
    alert("Error: " + JSON.stringify(error)); // Alert me bhi error dikhega
      });
  };

  return (
    <>
    <Navr/>
    
    <div className="contact-page">
      <header className="contact-hero">
        <div className="container">
          <h1 className="hero-title text-white">GET IN TOUCH</h1>
          <p className="lead text-light letter-spacing-2">LET'S PLAN YOUR NEXT BIG EVENT</p>
        </div>
      </header>

      <section className="container py-5">
        <div className="row g-5">
          
          {/* Left Side: Contact Info */}
          <div className="col-lg-5">
            <h2 className="text-white mb-4 fw-bold">Contact Info</h2>
            <div className="d-flex flex-column gap-4">
              <div className="contact-info-card">
                <div className="info-icon">📞</div>
                <div>
                  <h5 className="text-white mb-1">Phone</h5>
                  <p className="text-light mb-0">+91 93767-20138</p>
                </div>
              </div>
              <div className="contact-info-card">
                <div className="info-icon">✉️</div>
                <div>
                  <h5 className="text-white mb-1">Email</h5>
                  <p className="text-light mb-0">booking@tilluamplifier.com</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Working Form */}
          <div className="col-lg-7">
            <div className="glass-form-container">
              <h3 className="text-white mb-4">Send Us a Message</h3>
              
              {/* Success Message */}
              {submitted ? (
                <div className="alert alert-success bg-success text-white border-0">
                  ✅ <strong>Message Sent!</strong> Hum aapse jaldi contact karenge.
                </div>
              ) : (
                <form ref={form} onSubmit={sendEmail}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating form-floating-custom mb-3">
                        {/* name="user_name" zaroori hai EmailJS ke liye */}
                        <input type="text" name="user_name" className="form-control" placeholder="Name" required />
                        <label>Your Name</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-custom mb-3">
                        <input type="tel" name="user_phone" className="form-control" placeholder="Phone" required />
                        <label>Phone Number</label>
                      </div>
                    </div>
                  </div>

                  <div className="row g-3">
                    <div className="col-md-6">
                       <div className="form-floating form-floating-custom mb-3">
                        <select name="event_type" className="form-select bg-secondary text-white border-secondary">
                          <option value="Wedding">Wedding</option>
                          <option value="Birthday">Birthday</option>
                          <option value="Concert">Concert</option>
                          <option value="Other">Other</option>
                        </select>
                        <label>Event Type</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-custom mb-3">
                        <input type="date" name="event_date" className="form-control" placeholder="Date" />
                        <label>Event Date</label>
                      </div>
                    </div>
                  </div>

                  <div className="form-floating form-floating-custom mb-4">
                    <textarea name="message" className="form-control" style={{height: '120px'}} placeholder="Msg"></textarea>
                    <label>Tell us about your requirements...</label>
                  </div>

                  <button type="submit" disabled={loading} className="btn-neon-lg w-100 border-0" style={{background: 'linear-gradient(45deg, #d600ff, #00e5ff)', color: 'white'}}>
                    {loading ? 'SENDING...' : 'SEND MESSAGE'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footer/>
    </>
  );
}

export default Contact;